import { CardText, CardTextStrong } from "src/components/reports/cards/report-cards.styled";
import { TotalContainerStyled, TotalFlexStyled } from "src/pages/student-pages/cart/cart.styled";
import { FormatterUtils } from "@nubeteck/utils";
import { Space, Skeleton } from "antd";
import React, {useState, useEffect} from "react";
import { getBoxPage } from "../../../Api/content";
import { useLocale } from "../../../i18n/localeContext";
import { getUserEnrollementPage } from "../../../Api/content";
import { StrapiError } from "../../../pages/StrapiError";

interface ICartMoney {
  cargosMonedas: { colones: boolean; dolares: boolean };
  totalPendiente: { colones: number; dolares: number };
  totalCuotas: number;
  reglaEstimacion: number;
}

function CartMoneyInfo({
  cargosMonedas,
  totalPendiente,
  totalCuotas,
  reglaEstimacion,
}: ICartMoney) {
  const { locale } = useLocale();
  const [boxPage, setBoxPage] = useState<any>(null);
  const [userEnrollementPage, setUserEnrollementPage] = useState<any>(null);
  const [isLoadingContent, setIsLoadingContent] = useState<boolean>(true);
  const [hasError, setHasError] = useState<boolean>(false);

  useEffect(() => {
    let cancel = false;
    setHasError(false);
    setIsLoadingContent(true);
    
    const timeoutId = setTimeout(() => {
      if (!cancel) {
        setUserEnrollementPage(null);
        setBoxPage(null);
        setIsLoadingContent(false);
        setHasError(locale === 'en');
      }
    }, 3000);
    
    const loadContent = async () => {
      try {
        const [userEnrollementRes, boxRes] = await Promise.all([
          getUserEnrollementPage(locale),
          getBoxPage(locale)
        ]);
        
        if (!cancel) {
          clearTimeout(timeoutId);
          setUserEnrollementPage(userEnrollementRes?.data?.attributes || userEnrollementRes?.data || userEnrollementRes);
          setBoxPage(boxRes?.data?.attributes || boxRes?.data || boxRes);
          setIsLoadingContent(false);
        }
      } catch (error) {
        if (!cancel) {
          clearTimeout(timeoutId);
          setUserEnrollementPage(null);
          setBoxPage(null);
          setIsLoadingContent(false);
          setHasError(locale === 'en');
        }
      }
    };
    
    loadContent();
    
    return () => {
      cancel = true;
      clearTimeout(timeoutId);
    };
  }, [locale]);

  if (hasError && locale === 'en') {
    return <StrapiError
      onRetry={() => {
        setHasError(false);
        setIsLoadingContent(true);
      }}
      onUseDefault={() => {
        setHasError(false);
        setIsLoadingContent(false);
        setUserEnrollementPage(null);
        setBoxPage(null);
      }}
    />;
  }

  return (
    <TotalContainerStyled>
      <Space direction="vertical" style={{ paddingTop: 8 }}>
        {reglaEstimacion && (
          <TotalFlexStyled>
            <CardTextStrong>{isLoadingContent ? <Skeleton.Input active size="default" style={{ width: 100 }} /> : (userEnrollementPage?.cart_selection.rule_applied || "Regla aplicada")}</CardTextStrong>
            <CardText>{reglaEstimacion}</CardText>
          </TotalFlexStyled>
        )}
        <TotalFlexStyled>
        <CardTextStrong>{boxPage?.dashboardO || "Pago al contado"}</CardTextStrong>
          {cargosMonedas?.colones && (
            <CardText>{`₡ ${FormatterUtils.number(
              `${(totalPendiente.colones - totalCuotas > 0
                ? totalPendiente.colones - totalCuotas
                : 0
              ).toFixed(2)}`,
            )}`}</CardText>
          )}
          {cargosMonedas?.dolares && (
            <CardText>{`$ ${FormatterUtils.number(
              `${(totalPendiente.dolares - totalCuotas > 0
                ? totalPendiente.dolares - totalCuotas
                : 0
              ).toFixed(2)}`,
            )}`}</CardText>
          )}
        </TotalFlexStyled>
        <TotalFlexStyled>
        <CardTextStrong>{boxPage?.dashboardT || "Pago en cuotas"}</CardTextStrong>
          {cargosMonedas?.colones && (
            <CardText>{`₡ ${FormatterUtils.number(`${totalCuotas ?? 0}`)}`}</CardText>
          )}
          {cargosMonedas?.dolares && (
            <CardText>{`$ ${FormatterUtils.number(`${totalCuotas ?? 0}`)}`}</CardText>
          )}
        </TotalFlexStyled>
        <TotalFlexStyled>
        <CardTextStrong>{boxPage?.dashboardTR || "Total materias y servicios"}</CardTextStrong>
          {cargosMonedas?.colones && (
            <CardText>{`₡ ${FormatterUtils.number(
              `${(totalPendiente.colones ?? 0).toFixed(2)}`,
            )}`}</CardText>
          )}
          {cargosMonedas?.dolares && (
            <CardText>{`$ ${FormatterUtils.number(
              `${(totalPendiente.dolares ?? 0).toFixed(2)}`,
            )}`}</CardText>
          )}
        </TotalFlexStyled>
      </Space>
    </TotalContainerStyled>
  );
}

export default CartMoneyInfo;
